import { BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export function ReportResult({ result, title }) {
  if (!result) return <div className="card-tactical rounded-md p-10 text-center opacity-50 text-sm print:hidden" data-testid="rb-empty">Run the report to preview results here.</div>;
  const money = (v) => Number(v || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const hasSum = !!result.sum_label;
  const dataKey = hasSum ? "sum" : "count";
  return (
    <div className="space-y-4" data-testid="rb-result">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div>
          <div className="font-display font-black text-2xl">{title || result.source_label}</div>
          <div className="text-xs opacity-60" data-testid="rb-result-meta">{result.source_label} · {result.total} row{result.total === 1 ? "" : "s"}{result.truncated ? ` (showing first ${result.rows.length})` : ""} · run {result.ran_at?.slice(0, 16).replace("T", " ")}</div>
        </div>
        {result.grand_total !== null && result.grand_total !== undefined && (
          <div className="card-tactical rounded-md px-4 py-2 text-right" data-testid="rb-grand-total">
            <div className="text-[10px] tracking-widest uppercase opacity-60">Total {result.sum_label}</div>
            <div className="font-display font-black text-2xl text-[#83B68B]">{money(result.grand_total)}</div>
          </div>
        )}
      </div>

      {result.groups && (
        <div className="card-tactical rounded-md p-4" data-testid="rb-groups">
          <div className="text-[10px] tracking-widest uppercase opacity-70 mb-2">{hasSum ? `Total ${result.sum_label}` : "Count"} by {result.group_label}</div>
          {result.chart && result.groups.length > 0 && (
            <div className="h-56 print:h-48" data-testid={`rb-chart-${result.chart}`}>
              <ResponsiveContainer width="100%" height="100%">
                {result.chart === "line" ? (
                  <LineChart data={result.groups}><CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" /><XAxis dataKey="key" tick={{ fontSize: 10 }} interval={0} angle={-20} textAnchor="end" height={50} /><YAxis allowDecimals={!hasSum ? false : true} tick={{ fontSize: 10 }} width={hasSum ? 60 : 30} /><Tooltip formatter={(v) => hasSum ? money(v) : v} /><Line type="monotone" dataKey={dataKey} stroke="#83B68B" strokeWidth={2} dot /></LineChart>
                ) : (
                  <BarChart data={result.groups}><CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" /><XAxis dataKey="key" tick={{ fontSize: 10 }} interval={0} angle={-20} textAnchor="end" height={50} /><YAxis allowDecimals={!hasSum ? false : true} tick={{ fontSize: 10 }} width={hasSum ? 60 : 30} /><Tooltip formatter={(v) => hasSum ? money(v) : v} /><Bar dataKey={dataKey} fill="#83B68B" radius={[3, 3, 0, 0]} /></BarChart>
                )}
              </ResponsiveContainer>
            </div>
          )}
          <div className="flex flex-wrap gap-2 mt-2">
            {result.groups.map(g => <span key={g.key} className="text-xs px-2 py-1 rounded border border-border" data-testid="rb-group-chip">{g.key}: <strong>{g.count}</strong>{hasSum && <span className="text-[#83B68B]"> · {money(g.sum)}</span>}</span>)}
          </div>
        </div>
      )}

      <div className="card-tactical rounded-md overflow-x-auto" data-testid="rb-table">
        <table className="w-full text-xs">
          <thead><tr className="border-b border-border text-left">{result.columns.map(c => <th key={c.key} className="px-3 py-2 font-semibold whitespace-nowrap text-[10px] tracking-widest uppercase opacity-70">{c.label}</th>)}</tr></thead>
          <tbody>
            {result.rows.length === 0 ? <tr><td colSpan={result.columns.length} className="px-3 py-8 text-center opacity-50">No rows match.</td></tr>
              : result.rows.map((r, i) => <tr key={i} className="border-b border-border/50 hover:bg-muted/30" data-testid="rb-row">{r.map((v, j) => <td key={j} className={`px-3 py-1.5 whitespace-nowrap max-w-[280px] truncate ${result.columns[j].type === "num" ? "text-right tabular-nums" : ""}`} title={v}>{v}</td>)}</tr>)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
